import { jsx as _jsx } from "react/jsx-runtime";
import { SDUIProductTileImpressionProvider } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIProductTileImpressionProvider";
import { SDUITileRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/SDUITileRenderer";
import React from "react";
export var SDUITileWrapperComponentRenderer = function(param) {
    var component = param.component, loggingData = param.loggingData;
    var _component_tile_wrapper_component;
    if (!((_component_tile_wrapper_component = component.tile_wrapper_component) === null || _component_tile_wrapper_component === void 0 ? void 0 : _component_tile_wrapper_component.tile)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SDUIProductTileImpressionProvider, {
        loggingData: loggingData,
        children: /*#__PURE__*/ _jsx(SDUITileRenderer, {
            tileElement: component.tile_wrapper_component.tile,
            loggingData: loggingData
        })
    });
};
